module.exports = __webpack_public_path__ + "static/media/heroBannerDesktop.eb2ade82.webp";